<template>
    <div class="grid w-full grid-cols-1 gap-x-4 gap-y-8 py-3 sm:grid-cols-2">
        <div class="sm:col-span-1">
            <BaseInputCombobox
                v-model="country"
                :name="'tin[' + index + '].country'"
                :icon="GlobeIcon"
                :disabled="disabled"
                required
                label="Country of Tax residency"
                data-1p-ignore
                :options="getAllCountries()"
                nullable />
            <BaseInputCheckbox
                v-model="cantObtainTin"
                :disabled="disabled"
                standalone
                class="pt-2"
                :name="'tin[' + index + '].canObtainTin'"
                :label="$t('country_tax_residencies.cant_obtain_tin')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-if="cantObtainTin"
                v-model="no_tin_reason"
                :disabled="disabled"
                required
                :name="'tin[' + index + '].no_tin_reason'"
                label="Reason why you can't obtain a TIN for this country" />
            <BaseInputText
                v-else
                v-model="tin"
                :disabled="disabled"
                required
                :name="'tin[' + index + '].tin'"
                label="Taxpayer Identification Number (TIN)" />
            <div class="flex justify-end">
                <BaseButtonMuted v-if="index !== 0" :disabled="disabled" class="mt-2" size="sm" @click="emit('remove')"
                    >Remove</BaseButtonMuted
                >
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseInputCombobox from '../../../base/BaseInputCombobox.vue'
import BaseInputCheckbox from '../../../base/BaseInputCheckbox.vue'
import BaseInputText from '../../../base/BaseInputText.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { getAllCountries } from '../../../../data'

import { useVModels } from '@vueuse/core'
import { GlobeIcon } from '@heroicons/vue/solid'
import { onMounted, ref, watch } from 'vue'

const props = defineProps<{
    country: string
    tin: string
    no_tin_reason: string
    index: number
    disabled: boolean
}>()

const emit = defineEmits(['update:country', 'update:tin', 'update:no_tin_reason', 'remove'])

const { country, tin, no_tin_reason } = useVModels(props, emit)

const cantObtainTin = ref(false)

onMounted(() => {
    if (no_tin_reason.value) {
        cantObtainTin.value = true
    }
})

watch(cantObtainTin, (value) => {
    if (value) {
        tin.value = ''
    } else {
        no_tin_reason.value = ''
    }
})
</script>

<style scoped></style>
